<template>
  <div class="nav zhzw-asideNav">
    <!-- 向下一级和二级展开导航 -->
    <el-menu class="aside-nav"
      :class="tierDisplay?'submenu-nav':''"
      :default-active="path"
      :background-color="''"
      :collapse="collapse"
      @select="menuSelect">
      <!-- 展开 开启滚动条 -->
      <el-scrollbar style="height: 100%"
        v-if="!collapse">
        <div v-if="show"
          style="padding:8px;">
          <template v-for="(item, key) in menu">
            <el-submenu v-if="item.children && showChildren(item)"
              class="submenu1"
              :class="tierDisplay?'submenu-tier':''"
              :key="key"
              :index="item.path">
              <template slot="title">
                <svg-icon class="margin-right-5"
                  :name="item.icon?iconNameFormate(item.icon):''"></svg-icon>
                <span slot="title">{{item.label}}</span>
              </template>
              <template v-for="(item1, key1) in item.children">
                <template v-if="item1.children  && showChildren(item1)">
                  <el-submenu :key="item1.path"
                    class="submenu2"
                    :index="item1.path">
                    <template slot="title">
                      <svg-icon class="margin-right-5"
                        :name="item1.icon?iconNameFormate(item1.icon):''"></svg-icon>
                      <span slot="title">{{item1.label}}</span>
                    </template>
                    <template v-for="(item2) in item1.children">
                      <template v-if="item2.children  && showChildren(item2)">
                        <el-submenu :key="item2.path"
                          class="submenu3"
                          :index="item2.path">
                          <template slot="title">
                            <svg-icon class="margin-right-5"
                              :name="item2.icon?iconNameFormate(item2.icon):''"></svg-icon>
                            <span slot="title">{{item2.label}}</span>
                          </template>
                          <template v-for="(item3) in item2.children">
                            <el-menu-item class="children"
                              :key="item3.path"
                              :index="item3.path">{{item3.label}}</el-menu-item>
                          </template>
                        </el-submenu>
                      </template>
                      <el-menu-item v-else
                        class="children"
                        :key="item2.path"
                        :index="item2.path">{{item2.label}}</el-menu-item>
                    </template>
                  </el-submenu>
                </template>
                <el-menu-item v-else
                  class="children"
                  :key="key1"
                  :index="item1.path">{{item1.label}}</el-menu-item>
              </template>
            </el-submenu>
            <!-- 侧边外链 -->
            <el-menu-item v-else-if="item.url"
              class="nav-item"
              :key="key"
              :index="'out_link'"
              @click="linkHandle(item)">
              <svg-icon class="margin-right-5"
                :name="item.icon"></svg-icon>
              <span slot="title">{{item.label}}</span>
            </el-menu-item>
            <el-menu-item v-else
              class="nav-item"
              :key="key"
              :index="item.path">
              <svg-icon class="margin-right-5"
                :name="item.icon?iconNameFormate(item.icon):''"></svg-icon>
              <span slot="title">{{item.label}}</span>
            </el-menu-item>
          </template>
        </div>
      </el-scrollbar>
      <!-- 收起去掉滚动条，不去掉滚动条影响正常展示 -->
      <template v-else>
        <template v-for="(item, key) in menu">
          <el-submenu v-if="item.children && showChildren(item)"
            class="submenu1"
            :key="key"
            :index="item.path">
            <template slot="title">
              <svg-icon class="margin-right-5"
                :name="item.icon?iconNameFormate(item.icon):''"></svg-icon>
              <span slot="title">{{item.label}}</span>
            </template>
            <template v-for="(item1, key1) in item.children">
              <template v-if="item1.children  && showChildren(item1)">
                <el-submenu :key="item1.path"
                  class="submenu2"
                  :index="item1.path">
                  <template slot="title">
                    <svg-icon class="margin-right-5"
                      :name="item1.icon?iconNameFormate(item1.icon):''"></svg-icon>
                    <span slot="title">{{item1.label}}</span>
                  </template>
                  <template v-for="(item2) in item1.children">
                    <template v-if="item2.children  && showChildren(item2)">
                      <el-submenu :key="item2.path"
                        class="submenu3"
                        :index="item2.path">
                        <template slot="title">
                          <svg-icon class="margin-right-5"
                            :name="item2.icon?iconNameFormate(item2.icon):''"></svg-icon>
                          <span slot="title">{{item2.label}}</span>
                        </template>
                        <template v-for="(item3) in item2.children">
                          <el-menu-item class="children"
                            :key="item3.path"
                            :index="item3.path">{{item3.label}}</el-menu-item>
                        </template>
                      </el-submenu>
                    </template>
                    <el-menu-item v-else
                      class="children"
                      :key="item2.path"
                      :index="item2.path">{{item2.label}}</el-menu-item>
                  </template>
                </el-submenu>
              </template>
              <el-menu-item v-else
                class="children"
                :key="key1"
                :index="item1.path">{{item1.label}}</el-menu-item>
            </template>
          </el-submenu>
          <el-menu-item v-else-if="item.url"
            class="nav-item"
            :key="key"
            :index="'out_link'"
            @click="linkHandle(item)">
            <svg-icon class="margin-right-5"
              :name="item.icon"></svg-icon>
            <span slot="title">{{item.label}}</span>
          </el-menu-item>
          <el-menu-item class="nav-item"
            v-else
            :key="key"
            :index="item.path">
            <svg-icon class="margin-right-5"
              :name="item.icon?iconNameFormate(item.icon):''"></svg-icon>
            <span slot="title">{{item.label}}</span>
          </el-menu-item>
        </template>
      </template>
      <el-button class="collapse-btn"
        :icon="collapse ? 'el-icon-d-arrow-right' : 'el-icon-d-arrow-left'"
        circle
        @click="collapse=!collapse"></el-button>
    </el-menu>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import string from '../../../dist/utils/string.js'
export default {
  name: "asideNav",
  data() {
    return {
      path: this.$route.path,
      menu: [],
      collapse: false, // 收起侧边导航
      show: true
    };
  },
  props: {
    tierDisplay: {
      default: false
    }
  },
  computed: {
    ...mapGetters({
      getRouter: 'getRouter'
    })
  },
  watch: {
    $route(to, from) {
      if (to.meta.nav) {
        this.path = to.meta.nav;
      } else {
        this.path = to.path;
      }
    },
    getRouter(val) {
      this.show = false
      this.menu = val
      setTimeout(() => {
        this.show = true
      }, 0);
    },
    collapse(val) {
      // 更新侧边导航是否收起的状态
      this.$store.dispatch('updateCollapse', val)
    },
  },
  mounted() {
    // 更新侧边导航是否收起的状态
    this.$store.dispatch('updateCollapse', this.collapse)

    if (this.$route.meta.nav) this.path = this.$route.meta.nav;
    this.updateMenu();
  },
  methods: {
    iconNameFormate: string.iconNameFormate,
    showChildren(item) {
      return !item.children.every(elem => elem.hideNav);
    },
    updateMenu() {
      this.menu = this.$store.getters.getRouter
    },
    // 侧边导航有外链时，默认选中的path无效了，因此设置外链的index为统一值，只有非外链导航时才跳转路由
    // 当前路由和需要去往的路由相同时，路由不做跳转
    menuSelect(index, indexPath) {
      this.$store.state.keepAliveRoutes = [] //切换导航时清空上次路由缓存
      if (this.$route.path === index) return false
      if (index !== 'out_link') this.$router.push(index)
    },
    linkHandle(item) {
      switch (item.target) {
        case '_blank':
          let downloadWidnow = window.open()
          downloadWidnow.location.href = item.url
          break;
        case '_self':
          window.location.href = item.url
          break;
        default:
          {
            let downloadWidnow = window.open()
            downloadWidnow.location.href = item.url
          }
          break;
      }

    }
  }
};
</script>
<style lang="scss">
.zhzw-asideNav {
  .aside-nav:not(.el-menu--collapse) {
    width: 200px;
    height: 600px;
  }
  &.nav {
    height: 100%;
    z-index: 100;
    position: relative;
    .el-scrollbar__wrap {
      overflow-x: hidden;
    }
  }
  .aside-nav.el-menu {
    border: none;
    height: 100%;
    .el-submenu {
      .el-menu {
        margin-top: 8px;
      }
    }
    .el-submenu__title {
      color: #636b79;
      font-weight: bold;
      font-size: 14px;
      border-radius: 8px;
      height: 48px;
      line-height: 48px;
      &:hover,
      &:focus {
        background: #e9f2ff;
        position: relative;
      }
      i {
        width: auto !important;
        margin-right: 6px;
      }
      .el-icon-arrow-down {
        margin-right: 0px;
      }
    }
    .el-menu-item {
      height: 48px;
      line-height: 48px;
      font-weight: bold;
      font-size: 14px;
      color: #636b79;
      min-width: unset;
      border-radius: 4px;
      margin-top: 3px;
      i {
        width: auto !important;
        margin-right: 6px;
      }
    }
    .children {
      padding-left: 44px !important;
    }
    .children.active {
      background-color: $aside-children-bgc-active;
      color: white;
    }
    .el-menu--inline {
      // background-color: $--color-primary;
    }
    .el-menu-item:hover,
    .el-menu-item:focus {
      background-color: $--color-primary !important;
      color: white;
    }
    .el-menu-item.is-active {
      background: $--color-primary;
      position: relative;
      color: white !important;
      a,
      i {
        color: white;
      }
    }
  }
  .submenu1 {
    margin-top: 8px;
    &:nth-of-type(1) {
      margin-top: 0;
    }
  }
  .nav-item.is-active,
  .nav-item:hover,
  .nav-item:focus,
  .submenu1 > div:hover,
  .submenu1 > div:focus,
  .submenu1.is-active > div {
    background: #e9f2ff;
    position: relative;
  }
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.5s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
  .bottom-btn {
    background-color: #2a354e;
    height: 53px;
    border-top: 1px solid rgba(42, 46, 152, 0.1);
  }
  .collapse-btn {
    position: absolute;
    bottom: 0;
    right: 0;
    background-color: transparent;
    color: $aside-normal-font;
    border: none;
  }
}
</style>


// WEBPACK FOOTER //
// ../vue-common-laboratory/src/components/common/AsideNav.vue